import { clone } from '@edicom/common/object/clone';
import flatmap from './controller/flatmap';
import initScopeFactory from './controller/init-scope';
import initChildScopeFactory from './controller/init-child-scope';
import { bindFactory } from './controller/bindFactory';
import { bindDataFactory } from './controller/bindDataFactory';
import { bindRegisterFactory } from './controller/bindRegisterFactory';
import { createState } from './controller/create-state';
import {
  hideField,
  showField,
  isHiddenField,
  isLastVisibleField,
  updateStateField,
  updateStateColumn,
  udpateStateRegister,
  updateStateSection,
  setStateSection,
} from './controller/handle-state';

ecFormBuilderCtrl.$inject = ['$scope', 'ecFormBuilderService', 'dispatcherFactoryService', 'eventEmitterService', '$cacheFactory'];

export default function ecFormBuilderCtrl($scope, ecFormBuilderService, dispatcherFactoryService, eventEmitterService, $cacheFactory) {
  const api = this;

  this._init = ({ data, view, name = '', events, state, options = {} }) => {
    this.uuid = Math.floor(Math.random() * (999999 - 100000) + 100000);
    this.unbinds = [];
    this._flash = {};
    this.state = {};
    this._preloads = [];
    this.caches = [];
    this.name = name;
    this.data = data; //init data no : // this.data[this.view.model] = this.data[this.view.model] || {}; // init CAB
    this.view = clone(view); // creamos un clone del view porque se modifica cuando lo procesamos y no queremos modificar el view de fuera

    Object.assign($scope, this.data);

    this.options = Object.assign(options, this.view.options);
    this.view.options = Object.assign({}, this.options);
    this.options.isReadOnly = this.options.isReadOnly || false;
    this.options.cols = this.options.cols || '2';

    this.view.fbFlash = !!this.options.flash; // @odeniel indica si queremos usar el flash (solo ieces de momento entonces false por defecto)

    this.events = eventEmitterService();
    events && Object.keys(events).forEach(event => this.unbinds.push(this.events.on(event, events[event])));

    this.dispatcher = dispatcherFactoryService();
    this.dictionary = createDictionary(this.view);

    this.isRegister = viewField => !!viewField.properties;
    //this.isRequired = viewField => viewField.required; // @odeniel - faltaría un parse() para evaluar cuando es una expressión
    // @avaron - cuando es expresión lo dejamos como false para que no esté disabled el check
    this.isRequired = viewField => (isExpression(viewField.required) ? false : viewField.required);
    this.getSection = sectionName => this.view.properties.find(section => section.name === sectionName); // usado solo en ieceButtonManager cuando igual se podría usar el view
    this.sections = {}; // para almacenar (en section.service.js) los templates que se compilan (en fb-compile) si "optimize"

    // gestión del "state"
    this.state = createState(state, this.view, this.isRegister, () =>
      setTimeout(() => {
        this.events.emit('ecFormBuilder:state', api.state); // solo si state modificado
      })
    );
    this.getDefaultState = () => {
      return createState({}, this.view, this.isRegister, () => {});
    };
    this.hideField = hideField.bind(this);
    this.showField = showField.bind(this);
    this.isHiddenField = isHiddenField.bind(this);
    this.isLastVisibleField = isLastVisibleField.bind(this);
    this.updateStateSection = updateStateSection.bind(this);
    this.updateStateField = updateStateField.bind(this);
    this.setStateSection = setStateSection.bind(this);
    this.updateStateColumn = updateStateColumn.bind(this);
    this.udpateStateRegister = udpateStateRegister.bind(this);

    // api externa
    this.fn = ecFormBuilderService.fn(data, this.view.model);
    // @odeniel (mas que nada) para forcar que el grid resfresca sus celdas cuando es visible y no detecta solo que hay un cambio
    this.forceRefresh = () => this.events.emit('ecFormBuilder:forceRefresh');
    this.refresh = () => this.events.emit('ecFormBuilder:refresh');
    this.watch = (expression, fn) => $scope.$watch(expression, fn);

    // api interna
    this.initScope = initScopeFactory(data, this.dictionary, api);
    this.initChildScope = initChildScopeFactory(data, this.dictionary, api);
    this.bind = bindFactory(data, this);
    this.bindData = bindDataFactory(data);
    this.bindRegister = bindRegisterFactory(data);
    this.fbGrid = {
      lineNumber: {
        show: () => {
          if (this.options.isLineNumber) {
            return;
          } // ya esta visible
          this.options.isLineNumber = true;
          this.events.emit(`ecFormBuilder:fbGrid:lineNumber`, {
            show: true,
          });
        },
        hide: () => {
          if (!this.options.isLineNumber) {
            return;
          } // ya esta escondido
          this.options.isLineNumber = false;
          this.events.emit(`ecFormBuilder:fbGrid:lineNumber`, {
            show: false,
          });
        },
      },
    };

    this.caches = [];
    this.cache = currentName => {
      const key = `${this.uuid}_${currentName}`;
      for (let i = 0; i < this.caches.length; i++) {
        if (this.caches[i].info().id === key) {
          return this.caches[i];
        }
      }
      const cache = $cacheFactory(key, {
        number: 15,
      });
      this.caches.push(cache);
      return cache;
    };

    this.events.emit('ready', this);
  };

  this._destroy = () => {
    (this.unbinds || []).forEach(unbind => unbind());
    this.events && this.events.destroy();
    this.dispatcher && this.dispatcher.destroy();
    (this.caches || []).forEach(cache => cache.destroy());
  };
}

/**
 * Recorre cada propiedad del view,
 *  - les crea el .parent a cada campo
 *  - y les registra en el dictonary {model: viewField} para poder encontrar un viewField facilmente
 * @param {Object} view
 * @returns
 */
function createDictionary(view) {
  const dictionary = {};
  flatmap(view, (viewField, parent) => {
    // aprovechamos el flatmap que recorre todo el view para inicializar el parent de cada viewField
    // se tiene que hacer aqui (al menos al inicio) porque luego, no se recorren todos los campos desde el engine,
    // por ejemplo las columnas van por el fb-grid a parte. (y el viewField type array no es el mismo objeto por referencia)
    // el .parent se necesita para el fbFlash, la celda article,...
    viewField.parent = parent;

    // registramos el viewField en el dictionary
    if (viewField.model) {
      dictionary[viewField.model] = viewField;
    }
  });
  return dictionary;
}

function isExpression(condition) {
  return typeof condition === 'string' && condition !== 'true' && condition !== 'false';
}
